export type ChainWowPlotSpec = {
  cur: (number | null)[];
  prev: (number | null)[];
  labels: string[];
  curDates: string[];
  prevDates: string[];
  curWin: string;
  prevWin: string;
};

export function chainWowPlotSignature(spec: ChainWowPlotSpec, brand: string | undefined): string {
  return JSON.stringify({
    brand,
    series: ['วัน', 'สัปดาห์นี้', 'สัปดาห์ก่อน'],
    labels: spec.labels,
    curDates: spec.curDates,
    prevDates: spec.prevDates,
    curWin: spec.curWin,
    prevWin: spec.prevWin,
  });
}
